'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'boombox';
var width = 576;
var height = 512;
var aliases = [128254];
var unicode = 'f8a5';
var svgPathData = 'M56 0l-8 0 0 160-48 0 0 320 576 0 0-320-48 0 0-160-472 0zM512 160l-96 0 0-32-64 0 0 32-32 0 0-32-64 0 0 32-32 0 0-32-64 0 0 32-96 0 0-144 448 0 0 144zM56 176l504 0 0 288-544 0 0-288 40 0zm312-32l32 0 0 16-32 0 0-16zm-64 16l-32 0 0-16 32 0 0 16zm-96-16l0 16-32 0 0-16 32 0zM168 248a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm0 160a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm168-88a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm160 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoombox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;